module.exports = __webpack_public_path__ + "img/zxcTitle2.24b17da5.png";